export function bnr() {
  const bnr = document.querySelector('.c-bnr_tel');
  window.addEventListener('scroll', function(){
    if( 0 < window.scrollY ) {
      bnr.classList.add('is-view');
    } else {
      bnr.classList.remove('is-view');
    }
  });
}